export default __webpack_public_path__ + "static/asw-cfa290dc5c9659344d92b41608d445d8.webp";